module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8017.54996afd.png";